// app/src/lib/aspect.js — the aspect-ratio system (handoff: the Aspect chip cycles
// 9:16 → 16:9 → 1:1 → 4:5, and the Generating preview + Result player letterbox to it).
// Frame dimensions are the comps' exact per-aspect maps so the stage matches pixel-for-pixel.

export const ASPECTS = ['9:16', '16:9', '1:1', '4:5'];

export function nextAspect(a) {
  return ASPECTS[(ASPECTS.indexOf(a) + 1) % ASPECTS.length];
}

// desktop stage: a 460×470 letterbox (Quocia Studio.dc.html)
const FRAME_DESKTOP = {
  '9:16': [259, 460], '16:9': [460, 259], '1:1': [420, 420], '4:5': [368, 460],
};
// mobile stage: a full-width × 340 letterbox (Quocia Studio Mobile.dc.html)
const FRAME_MOBILE = {
  '9:16': [186, 330], '16:9': [330, 186], '1:1': [290, 290], '4:5': [264, 330],
};

export function frameDims(aspect, mobile = false) {
  const [w, h] = (mobile ? FRAME_MOBILE : FRAME_DESKTOP)[aspect] || FRAME_DESKTOP['9:16'];
  return { w, h };
}
